import React from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UpgradeRequiredModal = ({ isOpen, onClose, title, body, ctaHref = '/account', ctaText = 'Перейти в аккаунт' }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-4" role="dialog" aria-modal="true">
            <div className="w-full max-w-lg rounded-2xl bg-white border border-secondary-200 shadow-soft">
                <div className="px-5 py-4 border-b border-secondary-200 flex items-center justify-between">
                    <div className="min-w-0">
                        <div className="text-lg font-semibold text-secondary-900 truncate">{title || 'Функция недоступна'}</div>
                    </div>
                    <button
                        type="button"
                        className="p-2 rounded-lg hover:bg-secondary-50"
                        onClick={onClose}
                        title="Закрыть"
                    >
                        <X className="w-5 h-5 text-secondary-600" />
                    </button>
                </div>

                <div className="p-5">
                    <div className="text-secondary-700 whitespace-pre-line">
                        {body || 'Чтобы использовать эту функцию, нужно подключить пакет «Полный доступ».'}
                    </div>
                </div>

                <div className="px-5 py-4 border-t border-secondary-200 flex items-center justify-end gap-2">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            onClose?.();
                            navigate(ctaHref);
                        }}
                    >
                        {ctaText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeRequiredModal;

